import { createContext, useContext } from "react";

export type AnalyticsEventMetadataContextType = {
  metadata: {
    [key: string]: string | number | boolean;
  };
};

const AnalyticsEventMetadataContext =
  createContext<AnalyticsEventMetadataContextType>({
    metadata: {},
  });

export const useAnalyticsEventMetadataContext =
  (): AnalyticsEventMetadataContextType => {
    return useContext(AnalyticsEventMetadataContext);
  };

export default AnalyticsEventMetadataContext;
